import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FlexiOnboardingRouteData } from './flexi-onboarding.service';

@Component({
  selector: 'flexi-onboarding-container',
  templateUrl: './onboarding-container.component.html',
  styleUrls: ['./flexi-onboarding.scss'],
  standalone: false
})
export class OnboardingContainerComponent implements OnInit, OnDestroy {
  routeData!: FlexiOnboardingRouteData;

  private dataSub?: Subscription;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    // Subscribed rather than read off the snapshot: the grid route and the
    // per-record wizard route both render this container, so moving between
    // them can reuse the component instance and a snapshot read would keep
    // showing the view we arrived from.
    this.dataSub = this.route.data.subscribe(data => {
      this.routeData = data['onboarding'] as FlexiOnboardingRouteData;
    });
  }

  ngOnDestroy(): void {
    this.dataSub?.unsubscribe();
  }
}
